<template>
  <div id="grupoProdutosId">
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-else
    >
      <div
        id="idTable"
        style="overflow-x: auto;"
      >
        <table
          style="width: 100%; color: black; border-collapse: collapse;"
          class="elevation-1"
        >
          <thead>
            <tr>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              />
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Classificação Produto
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Quantidade
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Faturamento
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Desconto %
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                PM
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                CMV
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Vr. Unt. Cardex
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Margem Bruta R$
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Margem Bruta %
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              >
                Margem Contribuição %
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(item, index) in faturamentoGrupoProdutos"
            :key="item.id"
          >
            <!-- Linha principal -->
            <tr>
              <td style="text-align: center;">
                <button @click="toggleExpand(index)">
                  {{ expanded.includes(index) ? '▲' : '▼' }}
                </button>
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: left;"
              >
                {{ item.classificacao }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.quantidade }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.faturamento }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.desconto }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.precoMedio }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.cmv }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.valorUnitario }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.margemBruta }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.margemPorcentatemBruta }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.margemContribuicao }}
              </td>
            </tr>
            <!-- Linha expandida -->
            <tr
              v-if="expanded.includes(index)"
              :key="'expanded-' + item.id"
            >
              <td colspan="11">
                <table
                  id="tableExpandida"
                  style="width: 100%; border-collapse: collapse; margin-top: 10px;"
                >
                  <thead>
                    <tr>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center; width: 20.3%"
                      >
                        Produto
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Unidade
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Quantidade
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Faturamento
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Desconto %
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        PM
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        CMV
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Vr. Unt. Cardex
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Margem Bruta R$
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Margem Bruta %
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Margem Contribuição %
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(sub, idx) in item.dadosProduto"
                      :key="idx"
                    >
                      <td
                        id="dadoMovimentacao"
                        style="text-align: left;"
                      >
                        {{ sub.produto }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: left;"
                      >
                        {{ sub.unidade }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.quantidade }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.faturamento }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.desconto }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.precoMedio }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.cmv }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.valorUnitario }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.margemBruta }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.margemPorcentatemBruta }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.margemContribuicao }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import AnaliseMargem from '../../../../../services/analisemargem'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowFaturamentoVendas',
    emits: ['dadosMargemTotal'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa: [],
      vendedor: [],
      area: [],
      rede: [],
      supervisor: [],
      receita: [],
      segmento: [],
      headersGrupoProdutos: [
        { text: 'Classificação Produto', value: 'classificacao', width: '20%', class: 'black--text title' },
        { text: 'Quantidade', value: 'quantidade', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Desconto %', value: 'desconto', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'PM', value: 'precoMedio', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'CMV', value: 'cmv', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Vr. Unt. Cardex', value: 'valorUnitario', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta R$', value: 'margemBruta', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta %', value: 'margemPorcentatemBruta', align: 'right', width: '5%', class: 'black--text title' },
        { text: 'Margem Contribuição %', value: 'margemContribuicao', align: 'right', width: '5%', class: 'black--text title' },
      ],
      headersProdutos: [
        { text: 'Produto', value: 'produto', width: '20%', class: 'black--text title' },
        { text: 'Unidade', value: 'unidade', width: '10%', class: 'black--text title' },
        { text: 'Quantidade', value: 'quantidade', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Desconto %', value: 'desconto', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'PM', value: 'precoMedio', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'CMV', value: 'cmv', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Vr. Unt. Cardex', value: 'valorUnitario', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta R$', value: 'margemBruta', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta %', value: 'margemPorcentatemBruta', align: 'right', width: '5%', class: 'black--text title' },
        { text: 'Margem Contribuição %', value: 'margemContribuicao', align: 'right', width: '5%', class: 'black--text title' },
      ],
      faturamentoGrupoProdutos: [],
      expanded: [],
    }),

    created () {
      eventEmit.$on('show-dados-tabela', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('show-dados-tabela', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.empresa = select
        this.vendedor = vendedores
        this.area = areas
        this.rede = redes
        this.supervisor = supervisores
        this.receita = receita
        this.segmento = segmento

        this.showMargemGrupoProdutos()
      },

      async showMargemGrupoProdutos () {
        this.loading = true

        this.faturamentoGrupoProdutos = []
        this.expanded = []

        await AnaliseMargem.showAnaliseMargemGrupoProdutos(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.rede, this.supervisor, localStorage.tokencontrato, this.receita, this.segmento).then(resposta => {
          if (resposta.data.status) {
            this.faturamentoGrupoProdutos = resposta.data.dadosGrupoProdutos.map((item) => {
              var listaFaturamento = ({
                classificacao: item.classificacao,
                quantidade: parseFloat(item.quantidade).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                desconto: parseFloat(item.desconto).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) + '%',
                precoMedio: 'R$ ' + parseFloat(item.precoMedio).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }),
                cmv: parseFloat(item.cmv).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                valorUnitario: 'R$ ' + parseFloat(item.valorUnitario).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }),
                preco_medio: parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                margemBruta: parseFloat(item.margemBruta).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                margemPorcentatemBruta: parseFloat(item.margemPorcentatemBruta).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                margemContribuicao: parseFloat(item.margemContribuicao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                expandir: item.expandir,
                dadosProduto: this.dadosProdutos(item.dadosProdutos),
              })

              return listaFaturamento
            })

            eventEmit.$emit('dados-margem-total', resposta.data.valorFaturamentoTotal, resposta.data.valorCmvTotal, resposta.data.valorMargemBrutaTotal, resposta.data.porcentagemMargemBrutaTotal, resposta.data.porcentagemMargemContruibuicao)
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado') {
            this.faturamentoGrupoProdutos = []
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      dadosProdutos (value) {
        const dados = value.map((item) => {
          var listaDados = ({
            produto: item.produto,
            unidade: item.unidade,
            quantidade: parseFloat(item.quantidade).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            desconto: parseFloat(item.desconto).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) + '%',
            precoMedio: 'R$ ' + parseFloat(item.precoMedio).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }),
            cmv: parseFloat(item.cmv).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            valorUnitario: 'R$ ' + parseFloat(item.valorUnitario).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }),
            preco_medio: parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            margemBruta: parseFloat(item.margemBruta).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            margemPorcentatemBruta: parseFloat(item.margemPorcentatemBruta).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
            margemContribuicao: parseFloat(item.margemContribuicao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
          })

          return listaDados
        })

        return dados
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #grupoProdutos {
      font-size: 10px;
      max-width: 100%
    }

    #idTable {
      max-height: 500px;
      max-width: 370px !important;
      /* margin: 0 0 0 -1rem; */
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }

    #tableExpandida {
      margin: 0 0rem 0 0rem;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #grupoProdutosId {
      width: 100%;
    }

    #grupoProdutos {
      font-size: 10px;
      max-width: 100%;
    }
  }
</style>

<style lang="sass">
  #grupoProdutos
    data-table-scroll-bar-width: 17px

  #tableExpandProdutos
    margin: 0 0 0 3rem

</style>
